<template>
    <QuestionBaseQuiz :question="question" class="mt-1">
        <FormLabel :value="$t('messages.answer')" :for="`answer_${question.question_id}`" />
        <template v-if="question.graph?.type === 'R1Ddyn'">
            <div>
                <QuestionLineGraph :data="question.graph" :value="answer" />
            </div>
            <div>
                <input
                   type="range"
                   name="number"
                   class="w-full"
                   style="max-width: 500px"
                   v-model.trim="answer"
                   :min="question.graph.domainX[0]"
                   :max="question.graph.domainX[1]"
                   :step="question.graph.step"
                >
            </div>
        </template>
        <!-- native modifier has been removed, please confirm whether the function has been affected  -->
        <FormInput
            v-else
            :id="`answer_${question.question_id}`"
            v-model.trim="answer"
            :name="`answer_${question.question_id}`"
            @keypress.enter.prevent
            :placeholder="$t('messages.number')"
            type="number"
            @wheel.passive="$event.target.blur()"
            step="any"
            class="mt-1 w-40"
        />

        <div>
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body> {{ question.tolerance_info }} </template>
            </AlertMessage>
        </div>

        <div class="mt-1">
            <button @click="reset" :class="{ invisible: isEmpty }" class="text-gray-600" type="button">
                <svg
                    class="w-6 h-6 inline-block"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
                {{ $t('messages.delete_answer') }}
            </button>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
export default {
    name: 'QuestionMathNumberWithToleranceQuiz',
};
</script>
<script setup>
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import { computed, ref, watch } from 'vue';
import AlertMessage from '@/components/AlertMessage.vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';
import QuestionLineGraph from '@/components/Quiz/QuestionLineGraph.vue';

const props = defineProps({
    question: {
        required: true,
    },
    modelValue: {
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const answer = ref(props.modelValue);

function reset() {
    answer.value = null;
}

const isEmpty = computed(() => {
    return answer.value === '' || answer.value === null;
});

watch(
    () => answer.value,
    (newVal) => {
        emit('update:modelValue', newVal);
    },
    { immediate: true },
);
</script>
